import type { AlertsSummaryResult } from "@/modules/alerts/domain/contracts";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export const alertsApi = {
  async summary(): Promise<AlertsSummaryResult> {
    return fetcher.get(`${config.apiUrl}/alerts/summary`);
  },
};
